<template>
  <v-card
    width="100%"
    outlined
    color="secondary darken-1"
    rounded="xl"
    class="mb-4 d-none d-sm-block"
    style="max-width:240px;"
    dense
    min-width="250px"
    :dark="this.$vuetify.theme.dark"
  >
    <p class="text-overline ma-0 mx-4 mt-2 adaprimary--text">Mainos</p>
    <v-img
      v-if="ad.img_src || ad.show_default_icon"
      :src="ad.show_default_icon ? require('@/assets/crash.png') : ad.img_src"
      max-height="195px"
      contain
      class="pa-2"
    />
    <v-card-title class="text-h5 font-weight-bold nwhite--text">
      {{ ad.title }}
    </v-card-title>
    <v-card-text>
      <p class="nwhite--text ma-0">{{ ad.text }}</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="ad.button && !ad.use_adc_instead_of_href"
        :href="ad.button_href"
        target="_blank"
        rounded
        block
      >
        {{ ad.button }}
      </v-btn>
      <adpopup v-else-if="ad.button && ad.use_adc_instead_of_href" :ad="ad" />
    </v-card-actions>
  </v-card>
</template>
<script>
import adpopup from "@/components/adpopup";

export default {
  components: {
      adpopup
  },
  props: {
    ad: {
      type: Object,
      required: true
    }
  },
  mounted() {
    console.log(this.ad);
    console.log(!!this.ad.active);
  }
};
</script>
